export const COMPONENT_NAME = "shared-error";
